import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const NotesDialog = ({ open, onOpenChange, title, eyebrow, text, testId = "notes" }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="card-surface max-w-2xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid={`${testId}-dialog`}>
      <DialogHeader className="text-left">
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <DialogTitle className="font-display text-2xl font-extrabold leading-snug pr-6" data-testid={`${testId}-dialog-title`}>{title || "Show notes"}</DialogTitle>
        <DialogDescription className="sr-only">Full episode description</DialogDescription>
      </DialogHeader>
      <div className="overflow-y-auto min-h-0 pr-1 -mr-1">
        <p className="whitespace-pre-line leading-relaxed text-slate-300" data-testid={`${testId}-dialog-body`}>{text}</p>
      </div>
    </DialogContent>
  </Dialog>
);

export const ExpandableText = ({ text, full, lines = 2, className = "", testId = "expandable-text", title, eyebrow, onOpen }) => {
  const [open, setOpen] = useState(false);
  const short = text || "";
  const long = full || short;
  if (!long) return null;
  const canExpand = long.length > short.length || long.length > 140;
  return (
    <div className={className} data-testid={testId}>
      <p className={`whitespace-pre-line leading-relaxed line-clamp-${lines}`} data-testid={`${testId}-body`}>{short}</p>
      {canExpand && (
        <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (onOpen) onOpen(); else setOpen(true); }} className="mt-1 text-xs font-semibold text-sky-400 hover:text-sky-300 transition-colors" data-testid={`${testId}-toggle`}>
          Read more
        </button>
      )}
      {!onOpen && <NotesDialog open={open} onOpenChange={setOpen} title={title} eyebrow={eyebrow} text={long} testId={testId} />}
    </div>
  );
};
